export class CreateAnalystModel {
  analystId!: string;
  analystRole!: string;
  admin!: boolean;
  active!: boolean;
}
